// extracted by mini-css-extract-plugin
module.exports = {"list":"ScrapModal_list__10mrs","amountToScrap":"ScrapModal_amountToScrap__145LA","availableBalance":"ScrapModal_availableBalance__3d0U0","counter":"ScrapModal_counter__9jgeh"};